import { Host, h } from '@stencil/core';
export class AibaRecommendedArticles {
  constructor() {
    this.styles = undefined;
    this.data = undefined;
    this.handlers = undefined;
    this.carouselData = undefined;
    this.cards = undefined;
  }
  updateRecommendedArticles(event) {
    const res = event.detail ? event.detail : '';
    const data = this.data;
    this.data = Object.assign(Object.assign({}, data), { articles: res });
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.handleRecommendedArticlesOnLoad) {
      this.data = await this.handlers.handleRecommendedArticlesOnLoad(this.data);
    }
  }
  renderArticleList(data) {
    return this.carouselData ? (h("aiba-carousel", Object.assign({}, this.carouselData, { handleSliderNext: event => this.handlers && this.handlers.handleArticlesSliderNext & this.handlers.handleArticlesSliderNext(event), handleSliderPrev: event => this.handlers && this.handlers.handleArticlesSliderPrev & this.handlers.handleArticlesSliderPrev(event), handlers: this.handlers }), this.data && this.data['articles'].map(el => { var _a; return h("aiba-article", { detail: el, isButtonEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isButtonEnabled, data: data, handlers: this.handlers }); }))) : this.cards ? (h("div", { class: "article-card-list" }, this.data &&
      this.data['articles'].map(el => { var _a; return h("aiba-article-card", { detail: el, isButtonEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isButtonEnabled, data: data, handlers: this.handlers }); }))) : (this.data && this.data['articles'].map(el => { var _a; return h("aiba-article", { detail: el, isButtonEnabled: (_a = this.data) === null || _a === void 0 ? void 0 : _a.isButtonEnabled, data: data, handlers: this.handlers }); }));
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a['articles']) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
      ((_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c['elements']) === null || _d === void 0 ? void 0 : _d.map(element => {
        if (element && element['name'] === 'aiba-carousel') {
          this.carouselData = element;
        }
        if (element && element['name'] === 'aiba-cards') {
          this.cards = element;
        }
        if (element && element['name'] === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element && element['name'] === 'aiba-articles') {
          return this.renderArticleList(element['data']);
        }
      })), this.data &&
      !(((_e = this.data) === null || _e === void 0 ? void 0 : _e['articles']) && ((_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f['articles']) === null || _g === void 0 ? void 0 : _g.length) > 0) &&
      ((_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h['articlesCallFailed']) === null || _j === void 0 ? void 0 : _j['elements'].length) > 0 &&
      ((_l = (_k = this.data) === null || _k === void 0 ? void 0 : _k['articlesCallFailed']) === null || _l === void 0 ? void 0 : _l['elements'].map(element => {
        if (element && element['name'] === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element && element['name'] === 'aiba-alert') {
          return h("aiba-alert", Object.assign({}, element['data']));
        }
      }))));
  }
  static get is() { return "aiba-recommended-articles"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-recommended-articles.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-recommended-articles.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "carouselData": {},
      "cards": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-recommended-articles-changed",
        "method": "updateRecommendedArticles",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-recommended-articles.js.map
